<template>
  <div >
    <div v-if="showMember" class="dialog-overlay" >
      <div class="mdialog">
        <div class="mdialog-header" :class="showPro ? 'pro' : ''">
          <div class="mh-top">
            <div class="mt-left">
              <img class="avatar" v-if="intelligenceInfo.url"  :src="`${files}/${intelligenceInfo.url}?key=${Math.random()}`"   alt="" srcset="" />
              <img class="avatar" v-else :src="`${files}/el/uc/face/u${intelligenceInfo.id}.jpg?key=${Math.random()}`" alt="" srcset="" />
              <div class="mt-name">{{ intelligenceInfo.nikeName }}</div>
              <div class="mt-time" >
                <div v-if="!memberCategoryId">开通会员享更多权益</div>
                <div v-else class="mt-plus">
                  <img src="@/assets/imgs/plus-tab.png" v-if="memberCategoryId == 2902 || memberCategoryId == 3074" alt="">
                  <img src="@/assets/imgs/pro-tab.png" v-else alt="">
                  {{ dayjs(latestValidEndTime).format('YYYY/MM/DD') }}到期
                </div>
              </div>
            </div>
            <img class="mt-close" src="@/assets/imgs/m-close.png" alt="" @click="handleClose">

          </div>
          <div class="mh-tab">
            <div class="mb-tab1"  @click="clickTab(0)">PLUS会员</div>
            <div class="mb-tab2"  @click="clickTab(1)">PRO会员</div>
          </div>
        </div>
        <div class="mdialog-center">
          <div class="mc-left">
            <div class="m-list">
              <div class="m-item " :class="[item.productSystemDictId == memberChecked.productSystemDictId ? 'checked' :'', 
              showPro ? 'pro' : '',
              item.canBuy ?  '' : 'disabled']" v-for="(item, index) in plusOrProArrNow" :key="index" @click="clickItem(item)">
                <div class="m-name">{{ item.openType }}</div>
                <div class="m-price"><span>¥</span>{{ item.amount }}</div>
                <div class="m-price1"><span v-if="item.originalAmount">¥{{item.originalAmount}}</span></div>
                <div class="m-save"><span v-if="item.differentAmount">立省¥{{item.differentAmount}}</span></div>
                <div class="m-limit" v-if="item.limitDays">{{item.limitDays}}</div>
              </div>
            </div>
            <div class="m-compare">
              <div class="mb16">会员权益对比</div>
              <div class="m-imgw">
                <img v-if="showPro " src="@/assets/imgs/pro-list.png" alt="">
                <img v-else-if="memberChecked.memberCategoryId == 3074" :src="files + memberUrl"  alt="">
                <img v-else  src="@/assets/imgs/plus-list.png" alt="">
              </div>
            </div>
          </div>
          <div class="mc-right" v-if="memberChecked.amount">
            <div class="mcr-top">
              <div class="m-order">订单详情</div>
              <div class="mr-checked" >
                <div>{{ memberChecked.openType  }}</div>
                <div class="mrc-price">¥{{ memberChecked.amount }}</div>
              </div>
            </div>
            <div class="mcr-bottom">
              <div class="mb-price" >
                ¥{{memberChecked.amount}} <span>¥{{memberChecked.originalAmount}}</span>
              </div>
              <template v-if="!memberCategoryId">
                 <div class="mb-btn" :class="[showPro ? 'pro': '']" @click="clickPay" v-loading="loadingPay">立即开通</div>
              </template>
              <template v-else-if="memberCategoryId == 2902 || memberCategoryId == 3074">
                 <div class="mb-btn" v-if="!showPro"  @click="clickPay">立即续费</div>
                 <div class="mb-btn pro" v-else @click="clickPayUp" v-loading="loadingPay">升级PRO高级会员</div>
              </template>
              <template v-else-if="memberCategoryId == 2904">
                 <div class="mb-btn type1" v-if="!showPro" >当前为PRO高级会员</div>
                 <div class="mb-btn pro" v-else @click="clickPay">立即续费</div>
              </template>
              <!-- <div class="mb-btn" :class="[showPro ? 'pro': '', memberCategoryId == 2904 ? 'type1' : '']" @click="clickPay">
                <span v-if="!memberCategoryId">立即开通</span>
                <span v-if="memberCategoryId == 2902">立即续费</span>
                <span v-if="memberCategoryId == 2904">当前为PRO高级会员</span>
              </div> -->
              <div class="mb-agree">
                <img src="@/assets/imgs/member-agree.png" v-if="showAgree" @click="showAgree = !showAgree" alt="">
                <img src="@/assets/imgs/member-disagree.png" @click="showAgree = !showAgree" v-else alt="">
                <span @click="showAgreement = true">《会员开通协议》</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mdialog-footer">
        </div>
        <el-dialog
          v-model="showPayTips"
          width="420"
        >
        <template #header>
          <div class="tips-header">支付提示</div>
        </template>
          <div class="payTips">同意并接受《<span @click="showAgreement = true">会员开通协议</span>》</div>
          <template #footer>
            <div class="dialog-footer">
              <el-button type="primary" @click="clickAgree">
                同意并支付
              </el-button>
            </div>
          </template>
        </el-dialog>
        <el-dialog
          v-model="showUp"
          width="420"
        >
        <template #header>
          <div class="tips-header">会员升级</div>
        </template>
          <div class="payUp">
            当前会员周期内升级PRO会员需补差价
            <span>¥</span><span class="pu-price">{{memberChecked.realAmount}}</span>
          </div>
          <div class="pay-rule" @click="showRule = true">查看计算规则</div>
          <template #footer>
            <div class="dialog-footer">
              <el-button type="primary" @click="plusToPro">
                确 定
              </el-button>
            </div>
          </template>
        </el-dialog>
        <el-dialog
          v-model="showRule"
          width="420"
        >
        <template #header>
          <div class="tips-header">补差价规则</div>
        </template>
          <div class="pd-rule">
            <div>计算规则：</div>
            <div>1. 基础计算公式</div>
            <div>需补差价 =（高档月卡单价 - 低档月卡单价）×（剩余天数 ÷ 当月总天数）</div>
            <div class="ti2">    示例：低档月费 30 元、高档 60 元，当月 30 天，用户已用 10 天（剩余 20 天）。</div>
            <div class="mb26 ti2">    差价 =（60-30）×（20÷30）= 20 元，补完即享高档权益至原会员到期日。</div>
            <div>2. 简化与补充规则</div>
            <div class="ti2">    当月总天数统一按 “30 天” 计算，避免 28/31 天造成的微小差异，降低用户理解成本。</div>
            <div class="ti2">    剩余天数不足 1 天按 1 天算，不足 0.01 元按 0.01 元收取。</div>
          </div>
          <template #footer>
            <div class="dialog-footer">
              <el-button type="primary" @click="showRule = false">
                确 定
              </el-button>
            </div>
          </template>
        </el-dialog>
        <el-dialog
          v-model="showAgreement"
          width="1000"
        >
        <template #header>
          <div class="tips-header">会员开通协议</div>
        </template>
          <div class="pd-rule">
            <div>师学宝 AI 教师助手会员开通协议 </div> 
            <div>（2026 年 1 月版，适用于 Plus 基础会员 / Pro 高级会员）</div>

            <div> 欢迎您购买并使用师学宝 AI 教师助手会员权益（以下简称“本服务”）。本协议由【北京教培师训网络科技股份有限公司】（以下简称“本公司”或“我们”）与购买会员服务的自然人（以下简称“用户”或“您”）共同缔结。您勾选“已阅读并同意”或完成支付即表示自愿接受本协议全部条款；如不同意，请勿继续购买或使用。
            </div>

            <div>一、服务内容与版本  </div>
            <div>1.1 本服务指本公司通过Web、App等方式提供的“AI 教师助手”全部功能。 </div>
            <div>1.2 会员版本及核心权益以《AI 教师助手会员机制》公示表格为准，并作为本协议附件。如表格与条款正文冲突，以条款正文为准。 </div>
            <div>1.3 我们保留新增、删减或调整任一功能的权利，但须提前通过站内公告或电子邮件通知；如调整导致您已购核心权益实质性减少，您可依据第 6.2 条申请退还未使用部分费用。</div>

           <div> 二、计费与支付</div>
           <div> 2.1 定价 </div>
            <div>a) Plus 基础会员：包月 29.9 元/30日，年付 299 元/365日； </div>
           <div>b) Pro 高级会员：包月 59.9 元/30日，年付 599 元/365日。    </div>
           <div> 2.2 所有价格已含增值税。如国家税率调整，我们可相应调整定价并于调整前公告。 </div>
           <div> 2.3 您可通过微信、支付宝等渠道完成支付。到账之时起 24 小时内系统自动开通权益；超时未到账的，请联系客服人工处理。  </div>
            <div>2.4 您理解并同意：会员服务为虚拟产品，一经开通即视为已使用，除本协议第 6 条约定的可退情形外，不支持七天无理由退货。</div>

            <div>三、使用规范</div>
            <div>3.1 账号仅限您本人（或本机构）使用，禁止转让、出租、共享、继承或用于商业二次销售。</div>
            <div>3.2 您不得利用本服务从事以下行为：</div>
            <div>a) 侵犯他人知识产权、隐私权或其他合法权益； </div>
            <div>b) 上传、存储或传播含有淫秽、暴力、恐怖、诈骗、政治敏感等违法信息；</div>  
           <div>c) 对本服务进行反向工程、破解、爬取、批量导出或构造相似产品； </div>
           <div>d) 通过外挂、脚本、群控等方式恶意消耗调用次数或积分； </div>
            <div>e) 其他法律法规禁止或我们书面明确禁止的行为。  </div> 
           <div> 3.3 我们有权对异常调用进行实时熔断、次数扣减或封禁账号，并无需事先通知；情节严重者，我们保留追究法律责任的权利。</div>

            <div>四、数据与隐私  </div> 
            <div>4.1 我们将按照师学宝隐私政策收集、使用与存储您的数据。</div> 
            <div>4.2 您确认：为完成智能批改、备课等功能，您上传的学生作业、课件等资料可能包含第三方个人信息，已取得合法授权并同意我们用于模型优化。若您未获得授权，由您承担全部责任。</div>

           <div> 五、客服与技术支持 </div>
           <div> 5.1 服务时间  </div>
            <div>a) 智能客服：7×24 小时； </div>
           <div> b) 人工客服/顾问： </div>
              <div>– Plus：工作日 5×8（10:00–18:00），24 小时内响应；</div>  
             <div>– Pro：5×10（8:00–18:00），2 小时内响应。 </div>
            <div>5.2 故障报修渠道：</div> 
           <div> App 内“我–关于我们–客服电话”联系我们。 </div>
           <div> 5.3 因地震、洪水、火灾、战争、政府管制、网络病毒或第三方云服务故障等不可抗力导致服务中断，本公司不承担赔偿责任，但将尽合理努力降低影响。</div>

           <div>六、退款与终止  </div>
           <div> 6.1 自动续费 </div>
            <div>若您开通自动续费，可于下次扣费前 24 小时取消自动续费；未关闭的视为同意续费。  </div>
          <div>  6.2 有理由退款 </div>
           <div> 出现以下情形之一，您可向人工客服提交退款申请，我们审核通过后 15 个工作日内原路退回： </div>
           <div> a) 重复购买同一会员；  </div>
          <div>  b) 因我方原因导致核心权益连续 72 小时无法使用； </div>
           <div> c) 法律规定的其他应予退款情形。  </div>
            <div>6.3 无责任终止   </div>
            <div>若您违反第 3.2 条，我们有权立即终止服务、清空积分且不退款；造成损失的，您须额外赔偿。</div>

           <div> 七、积分与增值服务  </div>
           <div>  7.1 积分规则   </div>
          <div>  a) Plus：消费 1 元=1 积分，可兑换基础权益；  </div>
           <div> b) Pro：消费 1 元=2 积分，可兑换高级权益。    </div>
           <div> 7.2 积分有效期：自获得之日起 24 个月，逾期清零。 </div> 
            <div>7.3 积分不可折现、转让或用于非官方渠道交易。</div>

            <div>八、知识产权  </div>
           <div> 8.1 本服务及其所有输出（含文字、图片、音频、课件、PPT 模板等）的著作权、专利权及相关权益均归本公司或关联权利人所有，仅授予您在教学、教研场景下的非排他、不可转授权、不可转让的使用权。</div>  
           <div> 8.2 您对外发布或商业使用上述输出前，须获得本公司书面授权；否则我们有权追偿并按会员年度费用 10 倍收取违约金。</div>

            <div>九、责任限制 </div> 
           <div> 9.1 本服务按“现状”与“可得到”基础提供，我们对 AI 生成内容的准确性、完整性、适用性不作保证。    </div>
            <div>9.2 在任何情况下，本公司对您承担的最高赔偿责任不超过您已支付该会员年度费用的 100%；对间接、附带或惩罚性损失不承担责任。</div>

            <div>十、协议变更与争议解决 </div>
           <div> 10.1 我们可因业务调整或法律法规变化修改本协议，修改后的协议于公示 7 日后生效；您继续使用的视为接受。  </div>
           <div> 10.2 本协议适用中华人民共和国法律。因履行本协议产生的争议，双方应友好协商；协商不成，任一方可向法院提起诉讼。</div>

            <div>十一、联系方式</div> 
            <div>客服电话：400-100-0910（工作日 9:00–17:30）  </div>

            <div>十二、附则  </div>
            <div>12.1 本协议自您完成支付之日起生效，有效期至会员到期或本协议终止之日止。 </div> 
            <div>12.2 本协议与《隐私政策》《注册服务条款》等公开规则共同构成完整协议；如有冲突，以本协议为准。  </div>
            <div>12.3 若本协议任何条款被认定为无效，不影响其他条款之效力。</div>

            <!-- <div>计算规则：</div>
            <div>1. 基础计算公式</div>
            <div>需补差价 =（高档月卡单价 - 低档月卡单价）×（剩余天数 ÷ 当月总天数）</div>
            <div class="ti2">    示例：低档月费 30 元、高档 60 元，当月 30 天，用户已用 10 天（剩余 20 天）。</div>
            <div class="mb26 ti2">    差价 =（60-30）×（20÷30）= 20 元，补完即享高档权益至原会员到期日。</div>
            <div>2. 简化与补充规则</div>
            <div class="ti2">    当月总天数统一按 “30 天” 计算，避免 28/31 天造成的微小差异，降低用户理解成本。</div>
            <div class="ti2">    剩余天数不足 1 天按 1 天算，不足 0.01 元按 0.01 元收取。</div> -->
          </div>
          <template #footer>
            <div class="dialog-footer">
              <el-button type="primary" @click="showAgreement = false">
                确 定
              </el-button>
            </div>
          </template>
        </el-dialog>
      </div>

    </div>
    <div v-if="showPay" class="dialog-overlay" >
      <div class="mdialog">
         <div class="pm-header" >
            <div class="pmh-center">
              <div class="pmhc-left" @click="clickPayBack">
               <img src="@/assets/imgs/m-back.svg" alt="">
                返回
              </div>
              <img class="pmh-close" src="@/assets/imgs/m-close.png" alt="" @click="clickPayBack">
            </div>
            <div class="pmh-size"></div>
         </div>
         <div class="pm-center">
            <div class="pmc-left">
              <!-- <img :src="qurl" alt=""> -->
               <div class="qurl-wrap">
                <img class="qurl" :src="qurl" />
               </div>
               <div>
                <div>使用 支付宝 或 微信 </div>
                <div>扫一扫支付</div>
               </div>

            </div>
            <div class="pmc-right">
              <div class="pmr-top">
                <img class="avatar " v-if="intelligenceInfo.url"  :src="`${files}/${intelligenceInfo.url}?key=${Math.random()}`" alt="" srcset="" />
                <img class="avatar " v-else :src="`${files}/el/uc/face/u${intelligenceInfo.id}.jpg?key=${Math.random()}`" alt="" srcset="" />
                <div >{{ intelligenceInfo.nikeName }}</div>
              </div>
              <div class="pmr-info">
                <div class="pmr-line">
                  <div class="pmr-title">购买物品：</div>
                  <div>{{ memberChecked.openType  }}</div>
                </div>
                <div class="pmr-line">
                  <div class="pmr-title">交易订单：</div>
                  <div>{{memberOrder}}</div>
                </div>
              </div>
              <div class="pmr-price">
                <div>支付金额：</div>
                <div class="pmr-pricep">¥{{memberChecked.realAmount}}</div>
              </div>
            </div>
         </div>
      </div>

    </div>
    <div v-if="showMemberInsufficient && myMemberData.latestValidEndTime" class="dialog-overlay" >
      <div class="edailog" :class="memberCategoryId == 2904 ? 'pro' : ''">
        <img class="ed-close" src="@/assets/imgs/ex-close.png" alt="" @click="showMemberInsufficient = false">
        <div class="ed-content">
          <div>将在<span>{{dayjs(myMemberData.latestValidEndTime).format('YYYY年M月D日') }} </span>到期，</div>
          <div>续费可畅享尊贵权益。</div>
          <div class="ed-btn" @click="clickRenew">立即续费</div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script setup>
import { ElMessage, ElMessageBox  } from 'element-plus';
import { menuList, addFeedback, menuNewList, getHistoryList, logout,
    getPointLeft, memberProductList, canBuyMember, memberNuonuoCreate, getMemberQrImg,
    memberDealNuonuoPayedOrder, cancelMemberOrder , myMemberStatus
} from '@/api/index';
import { ref, computed, watch, onMounted } from 'vue';
import { mittBus } from "@/utils/bus";
import { useStore } from "vuex";
import location from "@/utils/location";
import { useRoute, useRouter } from 'vue-router';
import dayjs from 'dayjs'
const store = useStore();
const router = useRouter();
const route = useRoute();
const staticH = location.static1();
const files = location.files1();
const dataList = ref([]);
const dataNewList = ref([]);
const historyList = ref([]);
const chatType = computed(() => store.state.chatType || sessionStorage.getItem('chatType'));
const isLock = computed(() => store.state.isLock);
const intelligenceInfo = ref(JSON.parse(localStorage.getItem('intelligenceInfo')) || {}) ;
const memberCategoryId = ref()
const latestValidEndTime = ref()
const userId = ref()

const initMemberInfo = () => {
  const intelligenceData = localStorage.getItem('intelligenceInfo');
  if (intelligenceData) {
    intelligenceInfo.value = JSON.parse(intelligenceData) || {}
    memberCategoryId.value = intelligenceInfo.value?.memberCategoryId
    latestValidEndTime.value = intelligenceInfo.value?.latestValidEndTime
    userId.value = intelligenceInfo.value?.id
    myMemberStatusM()
    memberProductListM()
    getPointLeftM()
  }
}
let hasExecutedInit = false
let onMountedTimer = null

onMounted(() => {
  onMountedTimer = setTimeout(() => {
    if (!hasExecutedInit) {
      console.log('onMounted initMemberInfo')
      initMemberInfo()
    }
  }, 1500)
})

mittBus.on('loginSuccess', () => {
  hasExecutedInit = true
  if (onMountedTimer) {
    clearTimeout(onMountedTimer)
    onMountedTimer = null
  }
  initMemberInfo()
});

import useHomeStore from '@/store/home'
const homeStore = useHomeStore()

const loginHandle = () => {
  if (!intelligenceInfo.value?.nikeName) return homeStore.changeLogin();
};


const memberStatus = intelligenceInfo.value?.memberStatus //是否为会员（0=否，1=是）

const showMemberInsufficient = ref(false)
const myMemberData = ref({})
// 获取用户ID，用于生成localStorage的key



const myMemberStatusM = async () => {
  const memberInsufficientKey = `memberInsufficient_shown_${userId.value}`
  const res = await myMemberStatus()
  if(res.code == 200) {
    myMemberData.value = res.data
    if(res.data.memberInsufficient){
      // 检查localStorage中是否已经显示过该弹窗
      const hasShown = sessionStorage.getItem(memberInsufficientKey)
      console.log('hasShown', hasShown)
      if(!hasShown){
        showMemberInsufficient.value = true
        // 标记已显示过，避免再次弹出
        sessionStorage.setItem(memberInsufficientKey, 'true')
      }
    }else{
      showMemberInsufficient.value = false
    }
    console.log('')
  }
}


//点击续费弹窗按钮
const clickRenew = () => {
  showMemberInsufficient.value = false
  showMember.value = true
  // 默认标签页和选中项会在watch(showMember)中自动设置
}

// 会员窗口
const showMember = ref(false)

mittBus.on("showMember", (val) => {
  console.log('val',val)
  if(val == 1) {
    showMember.value = true
  }else{
    showMember.value = true
    showPro.value = true
    plusOrProArrNow.value = proArr.value
  }
});

// 监听showMember变化，当弹窗显示时设置默认选中项
watch(showMember, (newVal) => {
  if (newVal) {
    // 根据用户会员类别设置默认标签页
    if (memberCategoryId.value == 2904 ) {
      // PRO会员，默认显示PRO标签页
      showPro.value = true
      plusOrProArrNow.value = proArr.value
    } else {
      // PLUS会员或免费版，默认显示PLUS标签页
      showPro.value = false
      plusOrProArrNow.value = plusArr.value
    }
    // 设置默认选中项
    selectDefaultItem()
  }
})

const handleClose = () => {
  showMember.value = false
}

//点击tab
const showPro = ref(false)
const clickTab = (val) => {
  if (val == 1) {
    showPro.value = true
    plusOrProArrNow.value = proArr.value
  } else {
    showPro.value = false
    plusOrProArrNow.value = plusArr.value
  }
  // 切换标签页后，选中第一个可购买的月卡
  selectDefaultItem()
}
watch(showPro, (newVal) => {
  console.log('newVal', newVal)
  // 切换标签页时，自动选中默认项（在clickTab中已经处理，这里保留清空逻辑以防其他地方触发）
  // 如果plusArr或proArr已经有数据，则选中默认项
  if (plusArr.value.length > 0 || proArr.value.length > 0) {
    selectDefaultItem()
  } else {
    memberChecked.value = {}
  }
})

// 设置默认选中项：选中当前标签页中第一个canBuy为true的月卡
const selectDefaultItem = () => {
  const currentArr = showPro.value ? proArr.value : plusArr.value
  // 找到第一个canBuy为true
  const firstCanBuyMonthCard = currentArr.find(item => item.canBuy )
  if (firstCanBuyMonthCard) {
    memberChecked.value = firstCanBuyMonthCard
  }else{
    memberChecked.value = {}
  }
}

const memberChecked = ref({}) //选中的会员
const plusArr = ref([])
const proArr = ref([])
const plusOrProArrNow = ref([])
const memberUrl = ref()
//会员列表数据
const memberProductListM = async () => {
  const res = await memberProductList()
  if (res.code == 200) {
    console.log('memberProductListDTOList', res.data.memberProductListDTOList)
    plusArr.value = res.data.memberProductListDTOList.filter(item => item.memberCategoryId == 2902 || item.memberCategoryId == 3074 )
    console.log('res.data.plusArr', plusArr.value)
    proArr.value = res.data.memberProductListDTOList.filter(item => item.memberCategoryId == 2904)
    memberUrl.value = res.data.memberUrl
    // 根据用户会员类别设置默认标签页
    if (memberCategoryId.value == 2904  ) {
      // PRO会员，默认显示PRO标签页
      showPro.value = true
      plusOrProArrNow.value = proArr.value
    } else {
      // PLUS会员或免费版，默认显示PLUS标签页
      showPro.value = false
      plusOrProArrNow.value = plusArr.value
    }
    
    // 设置默认选中项
    selectDefaultItem()
    
    console.log('plusArr', plusArr.value)
    console.log('xxx')
  }
}

//点击某个会员
const clickItem = (item) => {
  if(item.canBuy){
    memberChecked.value = item 
  }
}


//是否同意协议
const showAgree = ref(true)
//协议详情
const showAgreement = ref(false)
//显示同意协议
const showPayTips = ref(false)
//显示会员升级提示
const showUp = ref(false)

//显示规则
const showRule = ref(false)
const clickAgree = () => {
  showPayTips.value = false
  showAgree.value = true
}

//点击支付
const memberOrder = ref()
const loadingPay = ref(false)
const clickPay = async (up) => {
  console.log('clickPay', up)
  //是否同意协议
  if(!showAgree.value){
    showPayTips.value = true
    return 
  }
  //loading是不再调用
  if(loadingPay.value){
    return
  }
  
  loadingPay.value = true
  // await cancelMemberOrderM()
  canBuyMemberM()
}

const clickPayUp = () => {
  //是否同意协议
  if(!showAgree.value){
    showPayTips.value = true
    return 
  }
  // 升级会员
  showUp.value = true

}


const canBuyMemberM = async () => {
  const res = await canBuyMember()
  if(res.code == 200 && res.data) {
    console.log('memberChecked', memberChecked.value)
    const res = await memberNuonuoCreate({
      "amount": memberChecked.value.realAmount, //订单金额
      "note": undefined, //订单留言
      "payType": undefined, //订单类型，默认为微信，2922微信，2924支付宝，2928小程序支付
      "productSystemDictId": memberChecked.value.productSystemDictId, //会员商品字典id
      "type": 2 //设备类型，0苹果，1安卓，2诺诺
    })
    if(res.code == 200){
      memberOrder.value = res.data
      await getPayInfoM()
    }else{
      ElMessage.warning(res.message)
      loadingPay.value = false
    }
  }else{
    ElMessage.warning(res.message)
  }
}

const plusToPro = () => {
  showUp.value = false
  clickPay()
}



const qurl = ref() //二维码
let Time 
const getPayInfoM = async () =>{

  const res = await getMemberQrImg({
    orderNo: memberOrder.value
  })

  if(res.code == 200){
    qurl.value = res.data.qurl + `?timestamp=${new Date().getTime()}`
    showPay.value = true
    loadingPay.value = false
    console.log('res',res.data)
    Time = setInterval(() => {
      getOrderStatus();
    }, 1000);
  }else{
    ElMessageBox.alert(res.message, '警告', {
      confirmButtonText: '确定',
      callback: () => {
        router.back()
      },
    })

  }
  // loading.value = false
}

let isSuccess = ref(false);
const getOrderStatus = async() =>{
  const res  = await memberDealNuonuoPayedOrder({orderId:memberOrder.value })
  if(res.code == 200 &&  res.data.payedFlag == true){
    clearInterval(Time);
    isSuccess.value = true;
    ElMessage.success('操作成功')
    setTimeout(() => {
      window.location.reload()
    }, 1000);
  }
}

//显示支付二维码
const showPay = ref(false)

const cancelMemberOrderM = async () => {
  const res = await cancelMemberOrder({})
  if(res.code == 200){
    console.log('xx')
  }
}

watch(showPay, (val) => {
  if(!val && Time){
    clearInterval(Time);
  }
},{
  immediate: true
})



const clickPayBack = () => {
  showPay.value = false
}



//获取余额
const pointLeft = ref()
const getPointLeftM = async () => {
  const res = await getPointLeft()
  if (res.code == 200) {
    pointLeft.value = res.data.pointLeft
  }
}





watch(route, (val) => {
  getHistoryListM();
});

// 查询菜单数据
const menuListM = () => {
  menuList().then(res => {
    if (res.code == 200) {
      dataList.value = res.data;
    } else {
      ElMessage.error(res.msg);
    };
  });
};
menuListM();
// 新查询菜单数据
const menuNewListM = () => {
  menuNewList().then(res => {
    if (res.code == 200) {
      dataNewList.value = res.data.clazzModule;
      store.commit('changeMenu', res.data)
    } else {
      ElMessage.error(res.msg);
    };
  });
};
menuNewListM();
// 获取历史记录
const getHistoryListM = () => {
  getHistoryList({
    curPage: 1,
    pageSize: 10
  }).then((res) => {
    if (res.code == 200) {
      historyList.value = res.data;
    } else {
      ElMessage.error(res.message);
    }
  });
};


</script>

<style lang="scss" scoped>
.mr8 {
  margin-right: 8px;
}
.mb16{
  margin-bottom: 16px;
}
.mb26{
  margin-bottom: 26px;
}
.ti2{
  text-indent: 2em; /* 缩进两个字符宽度 */
}
.curP{
  cursor: pointer;
}

.mr6 {
  margin-right: 6px;
}
.pm-header{
  background: url('@/assets/imgs/m-bg3.png') no-repeat;
  .pmh-center{
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 72px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #FFFFFF;
    font-weight: 400;
    .pmhc-left{
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .pmh-close{
      cursor: pointer;
    }
  }
  .pmh-size{
    height: 20px;
  }
}
.pm-center{
  display: flex;
  align-items: center;
  padding: 141px 205px 0 163px;
  .pmc-left{
    width: 280px;
    height: 344px;
    box-sizing: border-box;
    background: #F2F5F9;
    border-radius: 8px;
    margin-right: 64px;
    padding: 38px 33px 0 33px;
    text-align: center;
    .qurl-wrap{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 214px;
      height: 214px;
      background: #FFFFFF;
      border-radius: 8px;
      margin-bottom: 24px;
      .qurl{
        width: 210px;
        height: 210px;
      }
    }

  }
  .pmc-right{
    width: 328px;
    .pmr-top{
      display: flex;
      align-items: center;
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #191D20;
      font-weight: 600;
      padding-bottom: 24px;
      border-bottom: 1px solid #e8ecef;
      .avatar{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 8px;  
      }
    }
    .pmr-info{
      padding: 16px 0;
      border-bottom: 1px solid #e8ecef;
      margin-bottom: 32px;
      .pmr-line{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #191D20;
        font-weight: 400;
        width: 345px;
        .pmr-title{
          font-family: PingFangSC-Regular;
          font-size: 16px;
          color: #6E7881;
          font-weight: 400;
        }
      }
    }
    .pmr-price{
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #191D20;
      font-weight: 600;
      .pmr-pricep{
        font-family: PingFangSC-Semibold;
        font-size: 28px;
        color: #FF6830;
        font-weight: 600;
      }
    }

  }
}

.tips-header{
  font-family: PingFangSC-Semibold;
  font-size: 18px;
  color: #191D20;
  font-weight: 600;
}
.payTips{
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #191D20;
  line-height: 22px;
  font-weight: 400;
  span{
    color: #1B84FF;
  }
}
.payUp{
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #191D20;
  line-height: 33px;
  font-weight: 400;
  .pu-price{
    font-family: PingFangSC-Semibold;
    font-size: 24px;
    color: #FF4000;
    line-height: 33px;
    font-weight: 600;
  }
  span{
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #FF4000;
    line-height: 33px;
    font-weight: 600;
  }
}
.pay-rule{
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #1B84FF;
  font-weight: 400;
  cursor: pointer;
}
.pd-rule{
  max-height: 500px;
  overflow: scroll;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #191D20;
  font-weight: 400;
}

.pi{
  width: 228px;
  height: 42px;
  box-sizing: border-box;
  padding: 8px 16px;
  background: #F8EED5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #64360D;
  font-weight: 500;
  .pi-left{
    padding: 5px 0;
    .pil-small{
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #64360D;
      font-weight: 400;
      span{
        color: #FF4000;
      }
    }
  }
  .pi-btn{
    width: 58px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #64360D;
    border-radius: 12px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #FEE8BC;
    font-weight: 500;
  }
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  .edailog{
    width: 270px;
    height: 450px;
    background: url('@/assets/imgs/ex-plus.png') no-repeat;
    // background-color: pink;
    position: relative;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #191D20;
    text-align: center;
    line-height: 25px;
    font-weight: 400;
    &.pro{
      background: url('@/assets/imgs/ex-pro.png') no-repeat;
      .ed-content{
        .ed-btn{
          background: #1C1107;
          box-shadow: inset 0px 1px 9px 0px rgba(118,90,55,1);
          border-radius: 28px;
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #F5D294;
          font-weight: 600;
        }
      }

    }
    .ed-close{
      position: absolute;
      right: -32px;
      top: 15px;
      cursor: pointer;
    }
    .ed-content{
      position: relative;
      top: 183px;
      span{
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #FF4000;
        line-height: 25px;
        font-weight: 600;
      }
      .ed-btn{
        margin: 0 auto;
        margin-top: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 204px;
        height: 40px;
        background: #2B58AE;
        box-shadow: inset 0px 1px 9px 0px rgba(255,255,255,0.5);
        border-radius: 28px;
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #FFFFFF;
        font-weight: 600;
        cursor: pointer;
      }
    }

  }

  .mdialog {
    width: 1040px;
    height: 738px;
    border-radius: 16px;
    background-image: linear-gradient(180deg, #F5F7FB 0%, #FFFFFF 100%);

    .mdialog-header {
      background: url('@/assets/imgs/m-bg1.png') no-repeat;
      padding-bottom: 30px;

      &.pro {
        background: url('@/assets/imgs/m-bg2.png') no-repeat;
        .mh-top{
          .mt-left{
            .mt-name{
              font-family: PingFangSC-Semibold;
              font-size: 18px;
              color: #FFFFFF;
              font-weight: 600;
            }
            .mt-time{
              color: rgba(255, 255, 255, 0.60);
            }
          }
        }
        .mh-tab{
          .mb-tab1{
            font-size: 20px;
            color: rgba(255, 255, 255, 0.80);
          }
          .mb-tab2{
            font-size: 24px;
            color: #191D20;
          }
        }

      }

      .mh-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 24px 16px 16px;
        box-sizing: border-box;
        height: 72px;

        .mt-left {
          display: flex;
          align-items: center;
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #191D20;
          font-weight: 600;

          .avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 8px;
          }

          .mt-name {
            margin-right: 8px;
          }

          .mt-time {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: rgba(25, 29, 32, 0.60);
            font-weight: 400;
            .mt-plus{
              display: flex;
              align-items: center;
              img{
                width: 46px;
                height: 22px;
                margin-right: 6px;
              }
            }
          }
        }

        .mt-close {
          width: 16px;
          height: 16px;
          cursor: pointer;
        }

      }

      .mh-tab {
        height: 54px;
        line-height: 54px;
        display: flex;
        // align-items: center;

        .mb-tab1 {
          margin-right: 40px;
          flex: 1;
          cursor: pointer;
          font-family: AlimamaShuHeiTi-Bold;
          font-size: 24px;
          color: #191D20;
          text-align: center;
          font-weight: 700;
        }

        .mb-tab2 {
          flex: 1;
          cursor: pointer;
          font-family: AlimamaShuHeiTi-Bold;
          font-size: 20px;
          color: #374047;
          text-align: center;
          font-weight: 700;
        }
      }
    }

    .mdialog-center {
      display: flex;
      .mc-left {
        padding-top: 20px;
        height: 560px;
        flex: 1;
        padding-left: 48px;
        padding-right: 48px;
        overflow: scroll;
        .m-list {
          margin-bottom: 40px;
          justify-content: space-evenly;
          display: flex;
          .m-item {
            position: relative;
            text-align: center;
            width: 154px;
            height: 148px;
            box-sizing: border-box;
            padding-top: 13px;
            background: #FFFFFF;
            border-radius: 16px;
            // overflow: hidden;
            cursor: pointer;
            &.checked{
              background-image: linear-gradient(180deg, #FFF4C4 0%, #FEFBE8 76%);
              border: 2px solid rgba(255,211,96,1);
              .m-name{
                color: #894400;
              }
              .m-price {
                color: #894400;
              }
              .m-save {
                background: #FFD360;
                color: #894400;
              }
              &.pro{
                background-image: linear-gradient(180deg, #FFDCC4 0%, #FFFFFF 76%);
                border: 2px solid rgba(253,83,25,1);
                .m-name{
                  color: #191D20;
                }
                .m-price {
                  color: #FD5319;
                }
                .m-save {
                  background: #FD5319;
                  color: #FFFFFF;
                }
              }
            }
            &.disabled{
              background: #FFFFFF;
     
              .m-name{
                color: #95AAB9;
              }
              .m-price {
                color: #95AAB9;
              }
              .m-save {
                background: #F4F6F8;
                color: #95AAB9;
              }
            }

            .m-name {
              font-family: PingFangSC-Semibold;
              font-size: 18px;
              color: #191D20;
              font-weight: 600;
            }

            .m-price {
              font-family: PingFangSC-Semibold;
              font-size: 30px;
              color: #191D20;
              line-height: 42px;
              font-weight: 600;
              span{
                font-size: 24px;
              }
            }

            .m-price1 {
              height: 21px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #95AAB9;
              font-weight: 400;
              text-decoration: line-through;
            }

            .m-save {
              margin-top: 12px;
              background: #FFF3CC;
              height: 32px;
              line-height: 32px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #894400;
              font-weight: 400;
              border-radius: 0 0 16px 16px;
            }
            .m-limit{
              position: absolute;
              left: 0;
              top: -11px;
              width: 108px;
              height: 30px;
              background: url('@/assets/imgs/limit-day.png') no-repeat;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #FFFFFF;
              font-weight: 400;
              box-sizing: border-box;
              padding-left: 12px;
            }
          }
        }
        .m-compare{
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #191D20;
          font-weight: 600;
          .m-imgw{
            text-align: center;
            img{
              width: 690px;
            }
          }
        }
      }

      .mc-right {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        width: 255px;
        height: 526px;
        border-left: 1px dashed #afb6c0;
        box-sizing: border-box;
        padding: 0px 24px;
        .mcr-top{
          .m-order{
            margin-bottom: 12px;
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #191D20;
            font-weight: 500;
          }
          .mr-checked{
            display: flex;
            justify-content: space-between;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #191D20;
            font-weight: 400;
            .mrc-price{
              font-family: PingFangSC-Semibold;
              font-size: 14px;
              color: #191D20;
              font-weight: 600;
            }
          }
        }
        .mcr-bottom{
          .mb-price{
            margin-bottom: 4px;
            font-family: PingFangSC-Semibold;
            font-size: 28px;
            color: #FF6830;
            font-weight: 600;
            span{
              text-decoration: line-through;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #95AAB9;
              font-weight: 400;
            }
          }
          .mb-btn{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 208px;
            height: 48px;
            background-image: linear-gradient(270deg, #FFD360 0%, #FFEB99 100%);
            border-radius: 8px;
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #894400;
            font-weight: 600;
            cursor: pointer;
            margin-bottom: 16px;
            &.type1{
              background: #EBEBEB;
              color: #ABBBCD;
            }
            &.pro{
              background-image: linear-gradient(270deg, #FF2323 9%, #FD8C19 100%);
              box-shadow: inset 0px 1px 9px 0px rgba(255,255,255,0.5);
              border-radius: 8px;
              color: #FFFFFF;
            }
          }
          .mb-agree{
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: PingFangSC-Regular;
            font-size: 13px;
            color: #6E7881;
            font-weight: 400;
            img{
              width: 14px;
              height: 14px;
              cursor: pointer;
            }
          }
        }

      }
    }

    .mdialog-footer {
      display: flex;
      gap: 10px;
      margin-top: 20px;
      justify-content: flex-end;
    }

  }
}




.menu {
  padding: 16px 16px 12px;
  background: #F5F7FB;
  height: 100%;
  box-sizing: border-box;
  width: 260px;
  position: relative;
  display: flex;
  flex-direction: column;

  .title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 24px;
    cursor: pointer;

    .t_ai {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }

    .t_text {
      font-family: AlimamaShuHeiTi-Bold;
      font-size: 22px;
      color: #191D20;
      letter-spacing: 0;
      font-weight: 700;
    }
  }

  .box {
    flex: 1;
    overflow-y: hidden;
    /* 默认隐藏垂直滚动条 */
    scrollbar-gutter: stable;
    /* 预留滚动条位置，避免内容挤压 */
    width: 244px;

    .row {
      width: 210px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 36px;
      margin: 4px 0px;
      cursor: pointer;
      padding-left: 12px;

      span {
        font-size: 14px;
        color: #191D20;
        letter-spacing: 0;
        font-weight: 400;
      }

      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .rowp {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .select {
      background: #E6F0FB;
      border-radius: 8px;
    }

    .row:hover {
      background: #E6F0FB;
      border-radius: 8px;
    }

    .history {
      .historyTitle {
        width: 210px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 36px;
        margin: 4px 0px;
        padding-left: 12px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #63849D;
        letter-spacing: 0;
        font-weight: 400;

        .historyFlag {
          width: 22px;
          height: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .historyFlag:hover {
          background: rgba(27, 132, 255, 0.08);
          border-radius: 8px;
        }
      }

      .historyRow {
        width: 210px;
        height: 36px;
        line-height: 36px;
        margin: 4px 0px;
        cursor: pointer;
        padding-left: 12px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #191D20;
        letter-spacing: 0;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .historyRow:hover {
        background: #E6F0FB;
        border-radius: 8px;
      }
    }
  }

  /* 鼠标移入时显示滚动条 */
  .box:hover {
    overflow-y: auto;
  }

  .bottom {
    .member {
      height: 53px;
      box-sizing: border-box;
      padding: 8px 12px 8px 16px;
      background: #F8EED5;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-image: linear-gradient(-29deg, #FEE8C1 0%, #FAE4BB 68%);
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #64360D;
      font-weight: 500;

      .member-left {
        .member-left-small {
          font-size: 12px;

          span {
            color: #ff4000;
          }
        }
      }

      .member-btn {
        width: 58px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #64360D;
        border-radius: 12px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #FEE8BC;
        font-weight: 500;
        cursor: pointer;
      }
    }
    .free-noleft{
      position: relative;
      left: -5px;
      cursor: pointer;
    }

    .pay {
      height: 95px;
      background: url('@/assets/imgs/recharge.png');
      position: relative;
      right: 10px;
      cursor: pointer;

      .bot_text {
        position: absolute;
        left: 45px;
        top: 30px;

        div:nth-child(1) {
          font-size: 16px;
          color: #3691FC;
          letter-spacing: 0;
          font-weight: 600;
        }

        div:nth-child(2) {
          font-size: 12px;
          color: #374047;
          letter-spacing: 0;
          text-align: center;
          font-weight: 400;
        }
      }
    }

    .person {
      width: 220px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      justify-content: space-between;
      width: 227px;
      height: 40px;
      box-sizing: border-box;
      padding: 4px 8px;

      .person-left {
        display: flex;
        align-items: center;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #191D20;
        letter-spacing: 0;
        font-weight: 600;
        cursor: pointer;
        img {
          width: 28px;
          height: 28px;
          margin-right: 8px;
          border-radius: 100%;
        }

        .pl-member {
          margin-top: 2px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #6E7881;
          line-height: 14px;
          font-weight: 400;
        }

      }

    }
    .person1 {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
}

.dialog {
  ::v-deep .el-dialog {
    border-radius: 24px;
    padding: 32px 50px;
  }

  .switchTabs {
    font-family: PingFangSC-Regular;
    font-size: 22px;
    color: #6E7881;
    letter-spacing: 0;
    font-weight: 400;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .ft600 {
      font-family: PingFangSC-Semibold;
      color: #191D20;
      font-weight: 600;
    }

    .line {
      margin: 0 auto;
      margin-top: 8px;
      background-image: linear-gradient(90deg, #3BE1F9 0%, #3363FF 44%, #9377FF 100%);
      border-radius: 3px;
      width: 48px;
      height: 6px;
    }

    .whiteLine {
      margin: 0 auto;
      margin-top: 8px;
      background: #fff;
      border-radius: 3px;
      width: 48px;
      height: 6px;
    }
  }

  .dialog-title {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #191D20;
    letter-spacing: 0;
    font-weight: 400;
    margin-bottom: 14px;
    display: flex;
    align-items: center;

    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }

  ::v-deep .el-textarea__inner {
    background: #F4F8FD;
    border-radius: 16px;
    padding: 12px 16px;
    font-size: 16px;
  }

  .count {
    margin-top: 7px;
    margin-right: 16px;
    text-align: right;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #A6B6C8;
    letter-spacing: 0;
    font-weight: 400;
  }

  ::v-deep .el-dialog__body {
    padding-bottom: 0;
  }

  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .confirm {
    background-image: linear-gradient(90deg, #3BE1F9 0%, #3363FF 44%, #9377FF 100%);
    border-radius: 8px;
    width: 136px;
    height: 40px;
    box-sizing: border-box;
    // padding: 10px 45px;
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    color: #FFFFFF;
    letter-spacing: 0;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.popoverBox {
  height: 70vh;
  overflow-y: hidden;
  /* 默认隐藏垂直滚动条 */
  scrollbar-gutter: stable;
  /* 预留滚动条位置，避免内容挤压 */
  width: 216px;
}

/* 鼠标移入时显示滚动条 */
.popoverBox:hover {
  overflow-y: auto;
}

.popover {
  .popover_title {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #63849D;
    letter-spacing: 0;
    font-weight: 400;
    height: 44px;
    line-height: 44px;
    padding-left: 16px;
  }

  .popover_row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 36px;
    margin: 4px 0px;
    cursor: pointer;

    span {
      font-size: 14px;
      color: #191D20;
      letter-spacing: 0;
      font-weight: 400;
    }

    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
      margin-left: 16px;
    }
  }

  .popover_row:hover {
    background: #E6F0FB;
    border-radius: 8px;
  }
}
</style>
